import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { ApiHttpService } from 'cms/utils/http/api';

export default function UserGalleryController( userId,props) {

  const [userGalleries, setUserGalleries] = useState(null);
  const [addModalIsOpen, setAddModalIsOpen] = useState(false);

  const { isLoading, data ,refetch } = useQuery(['userGalleries', userId], () =>
    ApiHttpService.loadUserGalleries(userId),
    {
      onSuccess: (data) => {
        if (data.results) {
          setUserGalleries(data.results)
        }
      },
    }
  );

  const closeModal = () => {
    setAddModalIsOpen(false)
}

  return {
    isLoading,
    userGalleries,
    setUserGalleries,
    closeModal,
    addModalIsOpen,
    setAddModalIsOpen
  };;
}
